import $ from "jquery"
$(document).ready(function() {
    // If accordion does not exist
    if ($('#contact-faqs #accordion').length == 0) {
        $('#contact-faqs').hide();
    }
    // If accordion does not have questions or answers
    if ($('#accordion .question').length == 0 || $('#accordion .answer').length == 0) {
        $('#contact-faqs').hide();
    }

    // Set up the accordion for the page
    $('#accordion').find('.question').click(function() {
        //Expand or collapse this panel
        $(this).next().slideToggle('fast');
        //Hide the other panels
        $("#accordion .answer").not($(this).next()).slideUp('fast');
    });
});
